// extracted by mini-css-extract-plugin
export default {"adult_verification":"adult_verification__b729ef2d","icon":"icon__b729ef2d"};